/* @flow */

export default class ConfirmingTypeForm {
  confirmingType: number;

  constructor() {
    this.confirmingType = 0;
  }

}
